<nb-card class="edit-name-dialog">
  <nb-card-header>
    <nb-icon (click)="closeDialog()" icon="close-outline"></nb-icon>
    تغییر نام گروه داشبوردی
  </nb-card-header>
  <nb-card-body>
    <div>نامی برای گروه داشبوردی "{{ asset?.name }}" وارد کنید:</div>
    <input data-testid="name-input" type="text" nbInput status="info" [formControl]="assetName" />
  </nb-card-body>
  <div class="nb-card-footer">
    <button nbButton (click)="closeDialog()" class="cancle-button">
      انصراف
    </button>
    <button nbButton (click)="editAsset()" class="delete-button"
            [disabled]="!isNameValidState">
      تغییر نام
    </button>
  </div>
</nb-card>